var Backbone = require('backbone');
var _ = require('underscore');

var Index = require('pages/Index/Index');

module.exports = Backbone.Router.extend({

    routes: {
        '': 'index',
    },


    initialize: function() {
        this.index = new Index({
            router: this
        });
    },


    index: function () {
    },


    start: function () {
        var pushStateSupported = history && _.isFunction(history.pushState);

        Backbone.history.start({
            pushState: pushStateSupported,
            silent: false
        });
    }
});



/*****************
 ** WEBPACK FOOTER
 ** ./assets/app/Router.js
 ** module id = 5
 ** module chunks = 0
 **/